import HikSetDriverVehicleinfoRegistrationnumModal from './hik-set-driver-vehicleinfo-registrationnum-modal.vue'
export default HikSetDriverVehicleinfoRegistrationnumModal
